import { PureComponent, PropsWithChildren } from "react";

export default class DescriptionPaneEditorValue extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-description-pane__editor-value">
        {this.props.children}
      </div>
    );
  }
}
